import { IconButton, Tooltip } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

import { HelpFlag, isHelpFeatureEnabled } from "src/config/posthog";
import { useHelpDrawer } from "./HelpDrawerContext";

interface HelpButtonProps {
  color?: "inherit" | "default" | "primary" | "secondary";
  tooltipPlacement?: "right" | "bottom" | "top" | "left";
}

/**
 * Global help icon. Gated by the in-app-help-drawer flag.
 */
const HelpButton = ({
  color = "inherit",
  tooltipPlacement = "bottom",
}: HelpButtonProps) => {
  const { openDrawer } = useHelpDrawer();
  if (!isHelpFeatureEnabled(HelpFlag.HELP_DRAWER)) return null;

  return (
    <Tooltip title="Help" placement={tooltipPlacement}>
      <IconButton
        data-testid="hdr-btn-help"
        data-attr="header:btn:help"
        size="small"
        color={color}
        onClick={() => openDrawer({ entryPoint: "nav_button" })}
        aria-label="Open help"
      >
        <HelpOutlineIcon />
      </IconButton>
    </Tooltip>
  );
};

export default HelpButton;
